import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { IEnergyMeterList, IEnergyMeterLog } from '../models/energy-meter';

@Injectable({
  providedIn: 'root',
})
export class EnergyMeter {
  private baseUrl: string = `${environment.apiUrl}/energy-meter`;
  private http: HttpClient = inject(HttpClient);

  //signals for state
  energyMeters = signal<IEnergyMeterList[]>([]);
  energyMeterLog = signal<IEnergyMeterLog[]>([]);
  isLoadingLog = signal(false);
  isLoadingList = signal(false);
  errorMessage = signal('');

  getEnergyMeterList(controllerId: number): void {
    this.isLoadingList.set(true);
    this.errorMessage.set('');

    this.http
      .get<IEnergyMeterList[]>(`${this.baseUrl}/controller/${controllerId}`)
      .subscribe({
        next: (data) => {
          this.energyMeters.set(data);
          this.isLoadingList.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load EM.');
          this.isLoadingList.set(false);
        },
      });
  }

  getEnergyMeterLogAllMeters(controllerId: number): void {
    this.isLoadingLog.set(true);
    this.energyMeterLog.set([]);
    this.errorMessage.set('');

    this.http
      .get<IEnergyMeterLog[]>(`${this.baseUrl}/controller/${controllerId}/log`)
      .subscribe({
        next: (data) => {
          this.energyMeterLog.set(data);
          this.isLoadingLog.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load EM.');
          this.isLoadingLog.set(false);
        },
      });
  }

  updateFromSocket(data: IEnergyMeterList[]) {
    this.energyMeters.set(data);
  }
}
